import {addMonths} from 'date-fns';

import {SetValueConfig, UseFormReturn} from 'react-hook-form';

import {getApiDateString, parseDate} from 'shared/web';

import {BaseVehicle} from '../../types/BaseVehicle';

export interface FormCalculateServiceInspectionDateIntervalAction {
  form: UseFormReturn<BaseVehicle>;
  value: number | null;
}

const DEFAULT_OPTIONS = {
  shouldDirty: true,
  shouldValidate: true,
} satisfies SetValueConfig;

/**
 * XState action for calculating the next service inspection date.
 * Uses the last service inspection date and service inspection interval in months to calculate the next date.
 *
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance
 */
export const formCalculateServiceInspectionDateIntervalAction = (
  _context: unknown,
  params: FormCalculateServiceInspectionDateIntervalAction
): void => {
  const {form, value} = params;

  const lastServiceInspectionDate = form.getValues(
    `serviceIntervals.serviceInspection.lastServiceInspectionDate`
  );
  const serviceInspectionAfterMonths = value;

  if (!lastServiceInspectionDate || !serviceInspectionAfterMonths) {
    return;
  }

  const nextDate = addMonths(parseDate(lastServiceInspectionDate), serviceInspectionAfterMonths);

  form.setValue(
    `serviceIntervals.serviceInspection.nextServiceInspectionDate`,
    getApiDateString(nextDate),
    DEFAULT_OPTIONS
  );
};
